<div class="reports-costs-table-container table-responsive pt-3 pb-3">
  <ng-container>
    <div class="alert alert-info mb-4" role="alert" *ngIf="terminalsWithoutIrrigation.length > 0">
      {{ 'reports_no_data_irrigation_date' | translation }}
      <ul class="mb-0">
        <ng-container *ngFor="let terminal of terminalsWithoutIrrigation">
          <li>{{ terminal.name }} - <span>{{ terminal.vid }}</span></li>
        </ng-container>
      </ul>
    </div>
  </ng-container>

  <ng-container *ngFor="let tableData of tables; index as index">
    <div class="row">
      <mat-form-field appearance="fill">
        <mat-label>Válvulas seleccionadas</mat-label>
        <mat-select [formControl]="valvesForm[index]" multiple (selectionChange)="onValvesSelectionChange()">
          <mat-option *ngFor="let valveOptions of valvesOptions[index]" [value]="valveOptions.value">
            {{ valveOptions.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="!hasLines(tableData)">
      {{ 'reports_no_data' | translation }}
    </div>

    <div class="d-flex table-container" *ngIf="hasLines(tableData)">
      <div class="sticky-table d-flex">
        <table mat-table [dataSource]="tableData">
          <!-- TOP HEADER -->
          <ng-container matColumnDef="empty">
            <th mat-header-cell *matHeaderCellDef colSpan="5" class="invisible"></th>
          </ng-container>
          <ng-container matColumnDef="totals">
            <th mat-header-cell *matHeaderCellDef colSpan="2">
              {{ 'irrigation_total' | translation }}
            </th>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="stickyTopHeaderColumns"></tr>

          <!-- HEADER -->
          <ng-container matColumnDef="field">
            <th mat-header-cell *matHeaderCellDef class="invisible"></th>
            <ng-container *matCellDef="let element">
              <td *ngIf="element.field_show_cell"
                  [rowSpan]="element.field_rowspan"
                  [class]="additionalClass(element)"
                  class="field-cell">
                <div class="vertical-container">
                  <div class="vertical-text fw-bold">
                    {{ element.field }}
                  </div>
                </div>
              </td>
            </ng-container>
          </ng-container>
          <ng-container matColumnDef="terminal">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'terminal_terminal' | translation }}
            </th>
            <ng-container mat-cell *matCellDef="let element">
              <td *ngIf="element.terminal_show_cell"
                  [rowSpan]="element.terminal_rowspan"
                  [class]="additionalClass(element)"
                  class="terminal-cell"
              >
                <div class="vertical-container">
                  <div class="vertical-text">
                    <div class="fs-5 fw-bold">{{ element.terminal }}</div>
                    <div class="fs-6">{{ element.terminal_vid }}</div>
                  </div>
                </div>
              </td>
            </ng-container>
          </ng-container>
          <ng-container matColumnDef="water_system">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'irrigation_water_system' | translation }}
            </th>
            <ng-container mat-cell *matCellDef="let element">
              <td *ngIf="element.water_system_show_cell"
                  [rowSpan]="element.water_system_rowspan"
                  [class]="additionalClass(element)"
                  class="water-system-cell"
              >
                {{ element.water_system }}
              </td>
            </ng-container>
          </ng-container>
          <ng-container matColumnDef="group">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'irrigation_group' | translation }}
            </th>
            <ng-container mat-cell *matCellDef="let element">
              <td *ngIf="element.group_show_cell"
                  [class]="additionalClass(element)"
                  [rowSpan]="element.group_rowspan"
                  [colSpan]="element.group_colspan"
                  [innerHTML]="element.group"
                  [ngClass]="{
                'border-bottom-3': !element.is_totals && !element.is_last_water_system_group,
                'fw-bold': element.is_totals
              }"
                  class="group-cell"
              ></td>
            </ng-container>
          </ng-container>
          <ng-container matColumnDef="valve">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'irrigation_valve' | translation }}
            </th>
            <ng-container mat-cell *matCellDef="let element">
              <td *ngIf="element.valve_show_cell"
                  [class]="additionalClass(element)"
                  [innerHTML]="element.valve"
                  [ngClass]="{
                'border-bottom-3': element.is_last_group_valve && !element.is_totals  && !element.is_last_water_system_group,
                'fw-bold': element.is_totals
              }"
                  class="valve-cell"
              >
                {{ element.valve }}
              </td>
            </ng-container>
          </ng-container>

          <!-- TOTALS -->
          <ng-container matColumnDef="theoretical_total">
            <th mat-header-cell *matHeaderCellDef class="heading-values line-totals" style="display: none;">
              {{ 'reports_total_teoric' | translation }}
            </th>
            <td mat-cell *matCellDef="let element"
                class="line-totals"
                [class]="additionalClass(element)"
                [ngClass]="{
              'border-bottom-3': element.is_last_group_valve && !element.is_totals && !element.is_last_water_system_group,
              'fw-bold': element.is_totals
            }"
                style="display: none;">
              {{ round(element.theoretical_total) }}&nbsp;m³
            </td>
          </ng-container>
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef class="heading-values line-totals">
              {{ 'irrigation_total' | translation }}
            </th>
            <td mat-cell *matCellDef="let element"
                class="line-totals"
                [class]="additionalClass(element)"
                [ngClass]="{
              'border-bottom-3': element.is_last_group_valve && !element.is_totals && !element.is_last_water_system_group,
              'fw-bold': element.is_totals
            }">
              {{ round(element.total) }}&nbsp;m³
            </td>
          </ng-container>
          <ng-container matColumnDef="total_consumption">
            <th mat-header-cell *matHeaderCellDef class="heading-values line-totals">
              {{ 'reports_water_costs' | translation }}
            </th>
            <td mat-cell *matCellDef="let element"
                class="line-totals"
                [class]="additionalClass(element)"
                [ngClass]="{
              'border-bottom-3': element.is_last_group_valve && !element.is_totals && !element.is_last_water_system_group,
              'fw-bold': element.is_totals
            }">
              {{ amount(element.water_cost, element.currency) }}<!-- TODO element.total_consumption -->
            </td>
          </ng-container>
          <ng-container matColumnDef="total_comparative_deviation">
            <th mat-header-cell *matHeaderCellDef class="heading-values line-totals" style="display:none;">
              {{ 'reports_comparative_deviation' | translation }}
            </th>
            <td mat-cell *matCellDef="let element"
                class="line-totals"
                [class]="additionalClass(element)"
                [ngClass]="{
              'border-bottom-3': element.is_last_group_valve && !element.is_totals && !element.is_last_water_system_group,
              'fw-bold': element.is_totals
            }"
                style="display:none;">
              {{ round(element.total_comparative_deviation) }}%
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="stickyDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: stickyDisplayedColumns;"></tr>
        </table>
        <table *ngIf="!showDetails" class="toggle-details h-100 ms-2" (click)="toggleShowDetails(true)">
          <tr>
            <td>
              <div class="vertical-container">
                <div class="vertical-text">
                  {{ 'reports_view_details' | translation }}
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div class="scrollable-table d-flex" *ngIf="showDetails">
        <table mat-table [dataSource]="tableData" *ngIf="hasLines(tableData)">
          <!-- TOP HEADER -->
          <ng-container *ngFor="let timeRange of costsReportsData.time_ranges; let i = index">
            <ng-container [matColumnDef]="'range_' + i">
              <th mat-header-cell *matHeaderCellDef [colSpan]="i === 0 ? 3 : 3" [ngClass]="{ 'd-none': !showDetails }">
                {{ timeRange }}
              </th>
            </ng-container>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="topHeaderColumns"></tr>

          <!-- RANGES -->
          <ng-container *ngFor="let timeRange of costsReportsData.time_ranges; let i = index">
            <ng-container matColumnDef="consumption_{{ i }}">
              <th mat-header-cell *matHeaderCellDef class="heading-values time-ranges"
                  [ngClass]="{ 'd-none': !showDetails }">
                {{ 'reports_consumption' | translation }}
              </th>
              <td mat-cell *matCellDef="let element"
                  [class]="additionalClass(element)"
                  [ngClass]="{
                'd-none': !showDetails,
                'border-bottom-3': element.is_last_group_valve && !element.is_totals && !element.is_last_water_system_group
               }">
                {{ round(element.costs[i].consumption_m3) }}&nbsp;m³
              </td>
            </ng-container>
            <ng-container matColumnDef="water_price_{{ i }}">
              <th mat-header-cell *matHeaderCellDef class="heading-values time-ranges"
                  [ngClass]="{ 'd-none': !showDetails }">
                {{ 'reports_water_price' | translation }}
              </th>
              <td mat-cell *matCellDef="let element"
                  [class]="additionalClass(element)"
                  [ngClass]="{
                'd-none': !showDetails,
                'border-bottom-3': element.is_last_group_valve && !element.is_totals && !element.is_last_water_system_group
              }">
                <ng-container *ngIf="element.costs[i].water_price_m3 === null">
                  -
                </ng-container>
                <ng-container *ngIf="element.costs[i].water_price_m3 !== null">
                  {{ round(element.costs[i].water_price_m3) }}&nbsp;{{ element.currency.symbol }}/m³
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="water_cost_{{ i }}">
              <th mat-header-cell *matHeaderCellDef class="heading-values time-ranges"
                  [ngClass]="{ 'd-none': !showDetails }">
                {{ 'reports_water_costs' | translation }}
              </th>
              <td mat-cell *matCellDef="let element"
                  [class]="additionalClass(element)"
                  [ngClass]="{
                'd-none': !showDetails,
                'border-bottom-3': element.is_last_group_valve && !element.is_totals && !element.is_last_water_system_group
              }">
                <ng-container *ngIf="element.costs[i].water_cost === null">
                  -
                </ng-container>
                <ng-container *ngIf="element.costs[i].water_cost !== null">
                  {{ amount(element.costs[i].water_cost, element.currency) }}
                </ng-container>
              </td>
            </ng-container>
            <ng-container *ngIf="i > 0" matColumnDef="comp_deviation_{{ i }}">
              <th mat-header-cell *matHeaderCellDef class="heading-values time-ranges"
                  [ngClass]="{ 'd-none': !showDetails }" style="display:none;">
                {{ 'reports_comparative_deviation' | translation }}
              </th>
              <td mat-cell *matCellDef="let element"
                  [class]="additionalClass(element)"
                  [ngClass]="{
                    'd-none': !showDetails,
                    'border-bottom-3': element.is_last_group_valve && !element.is_totals && !element.is_last_water_system_group
                  }"
                  style="display:none;">
                {{ round(element.costs[i].comparative_deviation) }}%
              </td>
            </ng-container>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <!-- SHOW LESS -->
        <table *ngIf="showDetails" class="toggle-details h-100 ms-2" (click)="toggleShowDetails(false)">
          <tr>
            <td>
              <div class="vertical-container">
                <div class="vertical-text">
                  {{ 'reports_hide_details' | translation }}
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </ng-container>
</div>
